export default {
  popup: {
    new_order: "تم استلام طلب جديد",
    new_issue: "تم الإبلاغ عن مشكلة في الطلب",
    order_id: "رقم الطلب",
    view: "عرض",
    order: "الطلب",
    issue: "المشكلة"
  }
};